import apiClient from "./apiClient";
import { SupportPriority, SupportStatus, SupportTicket } from "../types/supportTicket";
import { readPage } from "../utils/paginatedResult";

export async function getSupportTickets(page = 1, limit = 10, search = "", status = "", filters: { priority?: string; startDate?: string; endDate?: string } = {}, signal?: AbortSignal) {
  const params = Object.fromEntries(Object.entries({ page, limit, search, status: status === "All" ? "" : status, ...filters }).filter(([, value]) => value !== "" && value !== undefined));
  return readPage<SupportTicket>((await apiClient.get("tickets", { params, signal })).data);
}
export async function getSupportTicket(ticketId: string, signal?: AbortSignal): Promise<SupportTicket> {
  return (await apiClient.get<SupportTicket>(`tickets/${encodeURIComponent(ticketId)}`, { signal })).data;
}
export async function updateSupportTicketStatus(ticketId: string, status: SupportStatus) {
  return (await apiClient.patch(`tickets/${encodeURIComponent(ticketId)}/status`, { status })).data;
}
export async function closeSupportTicket(ticketId: string, response: string) {
  return (await apiClient.patch("tickets/close", { ticketId, response })).data;
}
export async function createSupportTicket(body: { name: string; email: string; title: string; priority: SupportPriority }) {
  return (await apiClient.post("tickets/create", body)).data;
}
